export const css = {
	welcome: '_2ZPqWGNK',
	skip: '_1TdTCM93',
	' _key': 'landing-page/welcome-view'
};

export default css;
